import { Component, Input } from '@angular/core';

@Component({
    selector: 'message-cta',
    templateUrl: './message-cta.component.html',
    standalone: false
})
export class MessageCtaComponent {
    @Input()
    public buttonLink: string;

    @Input()
    public buttonText: string;
}
